/* U20 V45.8.185 — reliable Buy It Now checkout without Cart Drawer timing. */
(function () {
  'use strict';

  var RUNTIME_KEY = '__u20ReliableBuyNowV458185';
  var BUTTON_SELECTOR = '[data-u20-buy-now]';

  if (window[RUNTIME_KEY]) return;

  function routeRoot() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.theme && window.theme.routes && window.theme.routes.root) ||
      '/';

    return /\/$/.test(root) ? root : root + '/';
  }

  function cartAddUrl() {
    return routeRoot() + 'cart/add.js';
  }

  function checkoutUrl(button) {
    return button.getAttribute('data-u20-checkout-url') ||
      (routeRoot() + 'checkout');
  }

  function errorContainer(form) {
    return form && form.querySelector('[data-cart-errors-container]');
  }

  function clearError(form) {
    var container = errorContainer(form);
    if (!container) return;
    container.textContent = '';
    container.classList.remove('is-visible');
  }

  function readableError(value) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) return value.join(', ');

    try {
      return JSON.stringify(value);
    } catch (error) {
      return String(value);
    }
  }

  function showError(form, message) {
    var container = errorContainer(form);
    if (!container) return;

    var error = document.createElement('div');
    error.className = 'errors';
    error.textContent = message ||
      'Unable to proceed to checkout. Please try again.';
    container.replaceChildren(error);
    container.classList.add('is-visible');
  }

  function setPending(button, pending) {
    var label = button.querySelector('[data-u20-buy-now-text]');

    if (label && !button.hasAttribute('data-u20-buy-now-original-text')) {
      button.setAttribute(
        'data-u20-buy-now-original-text',
        label.textContent || 'BUY IT NOW'
      );
    }

    button.setAttribute('data-u20-buy-now-pending', pending ? 'true' : 'false');
    button.classList.toggle('is-loading', pending);

    if (pending) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'PROCESSING...';
      return;
    }

    button.disabled = false;
    button.removeAttribute('aria-busy');
    if (label) {
      label.textContent =
        button.getAttribute('data-u20-buy-now-original-text') || 'BUY IT NOW';
    }
  }

  function buildPayload(form, button) {
    var payload = new FormData(form);
    var buttonGroup = button.closest('.product__submit__item');
    var localQuantity = buttonGroup &&
      buttonGroup.querySelector('[name="quantity"]:not(:disabled)');
    var quantity = localQuantity ? localQuantity.value : payload.get('quantity');

    // The legacy markup contains one quantity field beside each action button.
    // Send exactly the value beside Buy It Now instead of duplicate quantities.
    payload.delete('quantity');
    payload.append('quantity', quantity || '1');
    return payload;
  }

  function responseError(response, payload) {
    var message = readableError(
      payload && (payload.description || payload.message || payload.status)
    );

    if (!message) message = 'Checkout request failed (' + response.status + ').';
    return new Error(message);
  }

  async function addAndCheckout(button, form) {
    var payload = buildPayload(form, button);

    if (!payload.get('id')) {
      throw new Error('Please select an available product option.');
    }

    var response = await fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: payload
    });

    var result = null;
    try {
      result = await response.json();
    } catch (error) {}

    if (!response.ok || (result && result.status)) {
      throw responseError(response, result);
    }

    window.location.assign(checkoutUrl(button));
  }

  function onClick(event) {
    var target = event.target;
    var button = target && target.closest
      ? target.closest(BUTTON_SELECTOR)
      : null;

    if (!button) return;

    // Capture before Broadcast's delegated [data-add-to-cart] click handler.
    // This button owns a separate add-and-checkout transaction.
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (
      button.disabled ||
      button.getAttribute('data-u20-buy-now-pending') === 'true'
    ) {
      return;
    }

    var form = button.form || button.closest('form');
    if (!form) return;

    clearError(form);
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    setPending(button, true);
    addAndCheckout(button, form).catch(function (error) {
      setPending(button, false);
      showError(form, readableError(error && error.message));
    });
  }

  document.addEventListener('click', onClick, true);

  window[RUNTIME_KEY] = {
    version: 'V45.8.185'
  };
})();
